module.exports = __webpack_public_path__ + "img/assistauto.f1652571.jpg";